import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { UsageReportService } from "app/views/oes/services/usage-report.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-threshold-modal",
  templateUrl: "./threshold-modal.component.html",
  styleUrls: ["./threshold-modal.component.scss"],
  providers: [UsageReportService],
})
export class ThresholdModalComponent implements OnInit {
  public formThresholdGroup: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<ThresholdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private usageReportService: UsageReportService,
    private toaster: ToastrService
  ) {}

  ngOnInit() {
    this.formThresholdGroup = this.addInputValidators();
  }

  closeDialog(values: any = null) {
    this.dialogRef.close(values);
  }

  addInputValidators(): FormGroup {
    return this.formBuilder.group(
      {
        lowerThreshold: new FormControl(this.data.lowerValue, [
          Validators.required,
          Validators.pattern("^(0?[0-9]|[0-9][0-9])$"),
        ]),
        upperThreshold: new FormControl(this.data.upperValue, [
          Validators.required,
          Validators.pattern("^[1-9][0-9]?$|^100$"),
        ]),
      },
      {
        validator: this.validateThresholdValues,
      }
    );
  }

  validateThresholdValues: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const lowerValue: number = control.get("lowerThreshold").value;
    const upperValue: number = control.get("upperThreshold").value;

    return lowerValue >= upperValue ? { incorrectValues: true } : null;
  };

  onSubmit() {
    if (this.formThresholdGroup.valid) {
      const data = {
        lowerValue: this.formThresholdGroup.value.lowerThreshold,
        upperValue: this.formThresholdGroup.value.upperThreshold,
      };

      this.usageReportService.saveUserThresholdValues(data).subscribe(
        (result) => {
          this.toaster.success("Changes were saved successfully", "Success", {
            timeOut: 3000,
          });
          this.closeDialog(data);
        },
        (error) => {
          this.toaster.error("Error saving changes.", "Service Error");
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/threshold-modal/threshold-modal.component.ts